import { api } from "@/lib/api";

export type PublicLeadIntent =
  | "request_access"
  | "contact";

export interface PublicLeadPayload {
  intent: PublicLeadIntent;
  email: string;
  name?: string;
  organisation?: string;
  message?: string;
  sourcePath?: string;
}

export function submitPublicLead(citySlug: string, payload: PublicLeadPayload) {
  return api.post(`/v1/public/${citySlug}/contact-leads`, payload, {
    skipAuth: true,
  });
}
